import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import About from '../About/About';
import Footer from '../Footer/Footer';
import Navbar from '../Header/Navbar';
import Avatar from '../Projects/Avatar';
import MainContent from '../MainContent/MainContent'
import Contact from '../Contact/Contact';
import Fade from 'react-reveal';
import { PuffLoader } from 'react-spinners';
const loaderStyle = `
display : block;
margin: auto;
`;
const Home = () => {
    const [loading, setloading] = useState(true);
    const [project, setProject] = useState([]);
    useEffect(() => {
        fetch('projects.json')
            .then(res => res.json())
            .then(data => {
                const firstThree = data.slice(0, 3); // Get the first 3 items
                setProject(firstThree);
                setloading(false);
            })
    }, [project])
    return (
        <>
            {!loading && <>
                <Navbar></Navbar>
                <MainContent></MainContent></>}


            <PuffLoader loading={loading} css={loaderStyle} color={"#5ED9D7"} size={150}></PuffLoader>

            {!loading && <>
                <About></About>
                <div id='projects' className='pt-5 pb-5'>
                    <div className="container text-white pt-5 pb-5">
                        <Fade bottom duration={2500} distance="40px">
                            <h1 className='title text-center fw-bold pb-2' ><span className='some'>Some of</span><span className='h'> My Projects</span></h1>

                        </Fade>
                        <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1 pt-5 pb-4">
                            {
                                project.map(p => <Avatar key={p.id} p={p}></Avatar>)
                            }
                        </div>
                        <Fade bottom duration={2500} distance="40px">
                            <div className="text-center">
                                <Link to='/projects' className='btnn btn text-white fw-bold'>See More</Link>
                            </div>
                        </Fade>

                    </div>
                </div>
                <Contact></Contact>
                <Footer></Footer>
            </>}


        </>


    );
};

export default Home;